/*! responsive-tables */
$(document).ready(function () {
    $('main table').not('[role="presentation"]').wrap('<div class="table-responsive"></div>');

    $('.table-responsive').doubleScroll();
});